import { collegeMap } from "../collegeMap"

export const returnExplanationText = (college, ttDescriptors, subScores) => {

  let testPolicy = college?.testPolicy
  let locationFlag = false

  const collegeName = collegeMap.find((col) => `${col.id}` == `${college.id}`)?.name

  let fitValue = ttDescriptors.fit

  let dynamicText = ``
  let locationText = ``

  if (subScores.admitRate == 1) {
    switch (subScores.testScores) {
      case 3:
        switch (subScores.grades) {
          case 3:
            dynamicText = `Your ${ttDescriptors.testScore} and ${ttDescriptors.grades} would make you a strong applicant for ${collegeName}.`
            break;
          case 2:
            dynamicText = `Your ${ttDescriptors.testScore} and ${ttDescriptors.grades} would make you a competitive applicant for ${collegeName}.`
            break;
          case 1:
            dynamicText = `Your ${ttDescriptors.testScore} ${ttDescriptors.testScoreCorr} strong but ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} below target for ${collegeName}.`
            break;
          case 0:
            dynamicText = `Your ${ttDescriptors.testScore} ${ttDescriptors.testScoreCorr} strong for ${collegeName} but there is insufficient info to assess your GPA/class rank. `
            break;
        }
        break;
      case 2:
        switch (subScores.grades) {
          case 3:
            dynamicText = `Your ${ttDescriptors.testScore} and ${ttDescriptors.grades} would make you a competitive applicant for ${collegeName}.`
            break;
          case 2:
            dynamicText = `Your ${ttDescriptors.testScore} and ${ttDescriptors.grades} would make you a competitive applicant for ${collegeName}.`
            break;
          case 1:
            dynamicText = `Your ${ttDescriptors.testScore} ${ttDescriptors.testScoreCorr} competitive but ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} below target for ${collegeName}, suggesting it would be a far reach.`
            break;
          case 0:
            dynamicText = `Your ${ttDescriptors.testScore} ${ttDescriptors.testScoreCorr} competitive for ${collegeName} but there is insufficient info to assess your GPA/class rank. `
            break;
        }
        break;
      case 1:
        switch (subScores.grades) {
          case 3:
            dynamicText = `Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} strong but ${ttDescriptors.testScore} ${ttDescriptors.testScoreCorr} below target for ${collegeName}.`
            break;
          case 2:
            dynamicText = `Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} competitive but ${ttDescriptors.testScore} ${ttDescriptors.testScoreCorr} below target for ${collegeName}.`
            break;
          case 1:
            dynamicText = `Your ${ttDescriptors.grades} and ${ttDescriptors.testScore} are below target for ${collegeName}, suggesting it would be a far reach.`
            break;
          case 0:
            dynamicText = `Your ${ttDescriptors.testScore} ${ttDescriptors.testScoreCorr} below target for ${collegeName} and there is insufficient info to assess your GPA/class rank. `
            break;
        }
        break;
      case 0:
        switch (subScores.grades) {
          case 3:
            dynamicText = `Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} strong for ${collegeName} but there is insufficient info to assess your test score. `
            break;
          case 2:
            dynamicText = `Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} competitive for ${collegeName} but there is insufficient info to assess your test score. `
            break;
          case 1:
            dynamicText = `Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} below target for ${collegeName} and there is insufficient info to assess your test score. `
            break;
          // case 0:
          //   break;
        }
        break;
    }

  } else if (subScores.admitRate == 2) {
    switch (testPolicy) {
      case 1:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target and this school has a test-required policy.`
                break;
              case 2:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target and this school has a test-required policy.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} and ${ttDescriptors.testScore} being below target.`
                break;
              case 0:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target and this school has a test-required policy.`
                break;
            }
            break;
          case 0:
            dynamicText = `Test score information is required to assess personal fit because ${collegeName} has a test required policy.`
            break;
        }
        break;
      case 2:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} and ${ttDescriptors.testScore} being below target.`
                break;
              case 0:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target.`
                break;
            }
            break;
          case 0:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
            }
            break;
        }
        break;
      case 3:
        switch (subScores.grades) {
          case 3:
            locationFlag = true;
            dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-blind policy.`
            break;
          case 2:
            locationFlag = true;
            dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-blind policy.`
            break;
          case 1:
            dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
            break;
        }
        break;
    }

  } else if (subScores.admitRate == 3) {
    switch (testPolicy) {
      case 1:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target and this school has a test-required policy.`
                break;
              case 2:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target and this school has a test-required policy.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} and ${ttDescriptors.testScore} being below target.`
                break;
              case 0:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target and this school has a test-required policy.`
                break;
            }
            break;
          case 0:
            dynamicText = `Test score information is required to assess personal fit because ${collegeName} has a test required policy.`
            break;
        }
        break;
      case 2:
        switch (subScores.testScores) {
          case 3:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 2:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore} and ${ttDescriptors.grades}.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
              case 0:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit} and your ${ttDescriptors.testScore}.`
                break;
            }
            break;
          case 1:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} and ${ttDescriptors.testScore} being below target.`
                break;
              case 0:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.testScore} being below target.`
                break;
            }
            break;
          case 0:
            switch (subScores.grades) {
              case 3:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 2:
                locationFlag = true;
                dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-optional policy.`
                break;
              case 1:
                dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
                break;
            }
            break;
        }
        break;
      case 3:
        switch (subScores.grades) {
          case 3:
            locationFlag = true;
            dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-blind policy.`
            break;
          case 2:
            locationFlag = true;
            dynamicText = `We estimate ${collegeName} is a ${fitValue} school based on its ${ttDescriptors.admit}, your ${ttDescriptors.grades}, and this school's test-blind policy.`
            break;
          case 1:
            dynamicText = `We estimate ${collegeName} is a ${fitValue} based on your ${ttDescriptors.grades} being below target.`
            break;
        }
        break;
    }
  }

  // Rule 64
  if (subScores.testScores === 0 && subScores.grades === 0 && (subScores.admitRate == 2 || subScores.admitRate == 3)) {
    dynamicText = `There is insufficient information published by ${collegeName} to compute a personalized fit based on your current user profile.`
  }

  // Rules 65-66
  if ((subScores.admitRate == 2 || subScores.admitRate == 3) && testPolicy == 3 && [1, 2, 3].includes(subScores.testScores) && subScores.grades === 0) {
    dynamicText = `There is insufficient information published by ${collegeName} to compute a personalized fit based on your current user profile.`
  }

  if (subScores.admitRate == 2 || subScores.admitRate == 3) {
    if (subScores.location == 1) {
      locationText = `We also consider that it's typically harder for out-of-state applicants to receive admission to public colleges.`
    } else if (subScores.location == 2) {
      locationText = `We also consider that there is typically some preference for in-state applicants at public colleges.`
    }
  }

  // // // // Separating return for admit rate 1; cases 1.13 - 1.20
  if (subScores.admitRate == 1 && [1, 2].includes(testPolicy) && subScores.testScores === 0) {
    let sentence1 = `Colleges with a very low (<15%) ${ttDescriptors.admit} are typically considered a Reach for all students.`
    let sentence2 = ``

    switch (subScores.grades) {
      case 3:
        return `${sentence1} Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} strong for ${collegeName} but there is insufficient info to assess your test score. `
      case 2:
        return `${sentence1} Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} competitive for ${collegeName} but there is insufficient info to assess your test score. `
      case 1:
        return `${sentence1} Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} below target for ${collegeName} and there is insufficient info to assess your test score. `
      case 0:
        return sentence1
    }

    return `${sentence1} ${sentence2}`
  }

  if (subScores.admitRate == 1 && testPolicy === 3 && subScores.testScores === 0) {
    let sentence1 = `Colleges with a very low (<15%) ${ttDescriptors.admit} are typically considered a Reach for all students.`
    let sentence2 = ``

    switch (subScores.grades) {
      case 3:
        return `${sentence1} Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} strong for ${collegeName}. `
      case 2:
        return `${sentence1} Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} competitive for ${collegeName}. `
      case 1:
        return `${sentence1} Your ${ttDescriptors.grades} ${ttDescriptors.gradesCorr} below target for ${collegeName}. `
      case 0:
        return sentence1
    }

    return `${sentence1} ${sentence2}`
  }

  return `${subScores.admitRate == 1 ? `Colleges with a very low (<15%) ${ttDescriptors.admit} are typically considered a Reach for all students.` : ''} ${locationFlag ? `${dynamicText} ${locationText}` : `${dynamicText}`}`
}